import MComponent from '../Toolkit/Components/Component';
import React, {ReactElement} from 'react';
import styles from './DrawnBySummary.module.css';
import {DrawingBySummary} from '../Api/ControllerTypes/DrawingTypes';

type Props = {
    SummaryList: DrawingBySummary[];
    Totals: DrawingBySummary;
};

type State = {};

class DrawnBySummaryControl extends MComponent<Props, State> {
    private pounds = Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
    });

    public render(): ReactElement {
        return <table className={styles.table}>
            <thead>
            <tr key={-1}>
                <th className={styles.header}>Drawn By</th>
                <th className={styles.header}>Number Of Drawings</th>
                <th className={styles.header}>Total Paid</th>
                <th className={styles.header}>Total Charged</th>
                <th className={styles.header}>Net Profit</th>
            </tr>
            </thead>
            <tbody>
                {this.props.SummaryList.map((r, index) =>
                    <tr key={index}>
                        <td className={styles.data}>{r.label}</td>
                        <td className={styles.data}>{r.drawingsNum}</td>
                        <td className={styles.data}>{this.pounds.format(r.paidSum)}</td>
                        <td className={styles.data}>{this.pounds.format(r.chargedSum)}</td>
                        <td className={styles.data}>{this.pounds.format(r.chargedSum - r.paidSum)}</td>
                    </tr>
                )}
                <tr key={-2}>
                    <td className={styles.totals}>{this.props.Totals.label}</td>
                    <td className={styles.totals}>{this.props.Totals.drawingsNum}</td>
                    <td className={styles.totals}>{this.pounds.format(this.props.Totals.paidSum)}</td>
                    <td className={styles.totals}>{this.pounds.format(this.props.Totals.chargedSum)}</td>
                    <td className={styles.totals}>{this.pounds.format(this.props.Totals.chargedSum - this.props.Totals.paidSum)}</td>
                </tr>
            </tbody>
        </table>;
    }
}

export default DrawnBySummaryControl;